var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.colorVariant.concat( _vm.sizeVariant,
    _vm.disabledVariant,
    ['rounded focus:outline-none inline-flex items-center justify-center'] ),attrs:{"type":"button","disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }